import { useUserPreferences } from 'lib/hooks/queries/user/useUserPreferences';

const useUserPreferencesState = (fields = []) => {
  const {
    data: userCalendarData,
    isLoading: isUserCalendarLoading,
    isFetching: isUserCalendarFetching,
    error: userCalendarError
  } = useUserPreferences({
    params: { name: 'user_calendar' },
    dependencies: ['user_calendar'],
    options: { enabled: fields.includes('user_calendar') }
  });

  const {
    data: userGeneralData,
    isLoading: isUserGeneralLoading,
    isFetching: isUserGeneralFetching,
    error: userGeneralError
  } = useUserPreferences({
    params: { name: 'user_general' },
    dependencies: ['user_general'],
    options: { enabled: fields.includes('user_general') }
  });

  const {
    data: userNotificationsData,
    isLoading: isUserNotificationsPreferencesLoading,
    isFetching: isUserNotificationsPreferencesFetching,
    error: userNotificationsPreferencesError
  } = useUserPreferences({
    params: { name: 'user_notifications' },
    dependencies: ['user_notifications'],
    options: { enabled: fields.includes('user_notifications') }
  });

  return {
    calendarPreferences: userCalendarData?.preferences?.value ?? {},
    generalPreferences: userGeneralData?.preferences?.value ?? {},
    notificationsPreferences: userNotificationsData?.preferences?.value ?? {},
    isLoading:
      isUserCalendarLoading || isUserGeneralLoading || isUserNotificationsPreferencesLoading,
    isFetching:
      isUserCalendarFetching || isUserGeneralFetching || isUserNotificationsPreferencesFetching,
    error: userCalendarError || userGeneralError || userNotificationsPreferencesError
  };
};

export default useUserPreferencesState;
